"use client"

import { useState } from "react"
import { NpButton } from "src/components/np-design/components/NpButton"
import { NpErrorMessage } from "src/components/np-design/components/NpErrorMessage"
import { NpInput } from "src/components/np-design/components/input/NpInput"
import { NpEmailPrivacy } from "src/components/np-design/sections/newsletter/NpEmailPrivacy"
import { NpEmailSignupSuccess } from "src/components/np-design/sections/newsletter/NpEmailSignupSuccess"
import { handleEmailChange, useKlaviyoFormSubmit } from "src/components/np-design/sections/newsletter/state"
import { genericErrorMessage } from "src/utilities/errorMessages"

export type NpEmailSignupFormProps = {
  listId: string
  name: string
}

export const NpEmailSignupForm = ({ listId, name }: NpEmailSignupFormProps) => {
  const [success, setSuccess] = useState(false)
  const { email, loading, error, handleSubmit } = useKlaviyoFormSubmit(listId, name, () => setSuccess(true))

  if (success) {
    return <NpEmailSignupSuccess />
  }

  return (
    <form
      onSubmit={handleSubmit}
      inert={loading}
      className="mx-auto flex w-100 max-w-full grid-cols-1 flex-col items-stretch gap-4 whitespace-nowrap xl:gap-6"
    >
      <NpInput
        type="email"
        autoComplete="home email"
        placeholder="E-Mail"
        required
        value={email.value}
        onChange={handleEmailChange}
      />

      <NpButton type="submit" size="md" loading={loading}>
        Jetzt anmelden
      </NpButton>

      {error && (
        <div className="text-base">
          <NpErrorMessage message={genericErrorMessage} />
        </div>
      )}

      <NpEmailPrivacy />
    </form>
  )
}
